





































import { Component } from 'vue-property-decorator'
import Posts from '~components/content/Posts.vue'
import SearchPagination from '~components/content/widgets/pagination/SearchPagination.vue'
import SearchRelevanceChooser from '~components/content/widgets/listings/SearchRelevanceChooser.vue'
import { ListingPage, ListingPageVariables } from '~base/mixins/listings'
import {
  VueMetaProperty,
  VueMetaInfo,
  ApolloOperationVariables,
} from '~base/common/types'
import Layout4 from '~components/content/layouts/Layout-4.vue'

@Component<ListingPage & SearchPage>({
  components: {
    Posts,
    SearchPagination,
    SearchRelevanceChooser,
  },

  head(): VueMetaInfo {
    return {
      title: this.title,
      meta: this.meta,
      link: this.link,
    }
  },

  apollo: {
    search: {
      query: require('~base/graphql/queries/SearchPosts.gql'),
      variables(): ListingPageVariables {
        return this.variables
      },
      prefetch({ route }: any): ApolloOperationVariables {
        return {
          first: this.$config.perPage,
          page: parseInt(route.params.page || '0'),
          query: route.query.s || '',
          order: this.sortorder,
        }
      },
      result({ data }) {
        this.gotResult(data)
      },
    },
  },
})
export default class SearchPage extends ListingPage {
  protected sortorder: string = 'POST_DATE'

  get sidebar() {
    return 'search'
  }

  get layouts() {
    return [{ component: Layout4, items: 2 }]
  }

  get linkPrefix(): string {
    return `/suche/${this.$route.query.s}`
  }

  get variables(): ListingPageVariables {
    const variables: ListingPageVariables = {
      first: this.perPage,
      page: parseInt(this.$route.params.page || '0'),
      query: this.$route.query.s || '',
      order: this.sortorder,
    }
    return variables
  }

  get title(): string {
    return `„${this.$route.query.s}“ - ${this.$root.$t(
      'seo.title.search'
    )}`.toString()
  }

  get meta(): VueMetaProperty[] {
    // related to vue-i18n issue #184 https://github.com/kazupon/vue-i18n/issues/184
    const description = this.$root
      .$t('seo.description.search', [this.$route.query.s])
      .toString()

    return [
      ...super.meta,
      { hid: 'robots', name: 'robots', content: 'noindex,follow' },
      { hid: 'description', name: 'description', content: description },
      { hid: 'og:title', name: 'og:title', content: this.title },
      { hid: 'og:description', name: 'og:description', content: description },
    ]
  }

  mounted() {
    this.$store.dispatch('ads/pageChanged', {
      pageType: 'index',
      category: this.$route.query.s,
    })
    this.$store.dispatch('tracking/trackSearchPage', this.$route.query.s)
  }

  loadMoreData() {
    const { endCursor } = this.search.pageInfo
    if (endCursor) {
      this.after = endCursor
      this.nextPage()
    }
  }
}
